/**
 * Cart pickup validation - checks if cart items have stale pickup dates
 */
(function(){
  const PC = window.PickupConfig;
  const REG = window.PICKUP_REGIONS;
  
  function validateCartPickup(){
    if(!PC || !REG) return;
    
    // Resolve current date in store timezone if helper is available
    const now = PC.getNowInTimezone ? PC.getNowInTimezone() : new Date();
    const region = 'us';
    
    // Look for cart items with pickup properties
    const cartItems = document.querySelectorAll('.xo-cart-item, .xo-cart-mini-item');
    
    cartItems.forEach(item => {
      // Check properties displayed
      const props = item.querySelectorAll('.xo-cart-item__option, .xo-cart-mini-item__option');
      let pickupDate = null;
      let pickupTime = null;
      
      props.forEach(prop => {
        const text = prop.textContent || '';
        if(text.includes('Pickup Date')) {
          // Extract date value
          const span = prop.querySelector('span:last-child');
          if(span) pickupDate = span.textContent.trim();
        }
        if(text.includes('Pickup Time')) {
          const span = prop.querySelector('span:last-child');
          if(span) pickupTime = span.textContent.trim();
        }
      });
      
      if(pickupDate) {
        // Try to parse date - format may vary
        const parsedDate = PC.parseLocalDateISO ? PC.parseLocalDateISO(pickupDate) : null;
        if(!parsedDate) {
          // Try other formats
          const d = new Date(pickupDate);
          if(isNaN(d.getTime())) return;
        }
        const dateToCheck = parsedDate || new Date(pickupDate);
        const today = PC.startOfDay ? PC.startOfDay(now) : new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const checkDay = PC.startOfDay ? PC.startOfDay(dateToCheck) : new Date(dateToCheck.getFullYear(), dateToCheck.getMonth(), dateToCheck.getDate());
        
        // If date is in the past
        if(checkDay < today) {
          showPickupError(item, 'Your pickup date has passed. Please update your pickup time.');
          return;
        }
        
        // If it's today, check if time has passed
        if(PC.toDateKey && PC.toDateKey(checkDay) === PC.toDateKey(today)) {
          if(pickupTime) {
            const timeMins = PC.parseTimeToMinutes ? PC.parseTimeToMinutes(pickupTime) : null;
            if(timeMins != null) {
              const nowMins = now.getHours() * 60 + now.getMinutes();
              if(timeMins < nowMins) {
                showPickupError(item, 'Your pickup time has passed. Please update your pickup time.');
                return;
              }
            }
          }
        }
      }
    });
  }
  
  function showPickupError(item, message) {
    // Avoid duplicate errors
    if(item.querySelector('.cart-pickup-error')) return;
    
    const error = document.createElement('div');
    error.className = 'cart-pickup-error';
    error.style.cssText = 'color: #d72c0d; font-size: 0.875rem; margin-top: 0.5rem; padding: 0.5rem; background: #fef1f1; border-radius: 4px;';
    error.textContent = message;
    
    // Try to insert after options or in a visible place
    const options = item.querySelector('.xo-cart-item__options, .xo-cart-mini-item__options');
    if(options) {
      options.after(error);
    } else {
      item.appendChild(error);
    }
  }
  
  // Run on load and when cart updates
  if(document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', validateCartPickup);
  } else {
    validateCartPickup();
  }
  
  // Also watch for cart updates
  if(window.MutationObserver) {
    const observer = new MutationObserver((mutations) => {
      // Debounce
      clearTimeout(window._pickupCartValidateTimer);
      window._pickupCartValidateTimer = setTimeout(validateCartPickup, 500);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
